import { useEffect, useState, useRef } from 'react';
import { FetchPschometricChart, FetchTags } from '../../services/Charts.js';
import './index.css';
import Cookies from 'js-cookie';
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, Cell, CartesianGrid, Pie, PieChart, Legend } from "recharts";
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';

function PsychometricTestChart() {
    const [error, setError] = useState('');
    const [chartData, setChartData] = useState([]);
    const [tags, setTags] = useState();
    const chartRef = useRef(null); // 👈 Chart container ref

    const retrieveTags = async () => {
        const response = await FetchTags();
        setTags(response.data);
    };

    const colors = ['#118693', '#82ca9d', '#ffc658', '#ff7300', '#d45087'];

const findTags = async () => {
    const response = await FetchPschometricChart(Cookies.get('id'));
    if (response.success) {
        const formattedData = response.data.map((item, index) => {
            const percentage = item.percentage || 0;
            const tagName = item._id || 'Unknown';

            console.log(`Tag: ${tagName}, Percentage: ${percentage}%`);
            
            return {
                tag: tagName,
                percentage: percentage,  // ✅ Direct from API
                color: colors[index % colors.length]
            };
        });
        
        console.log('testchart', response, formattedData);
        setChartData(formattedData);
    } else {
        setError(response.message);
    }
};

    useEffect(() => { findTags(); }, [tags]);
    useEffect(() => { retrieveTags(); }, []);

    const downloadPDF = () => {
        if (!chartRef.current) return;
        html2canvas(chartRef.current, { scale: 2 }).then((canvas) => {
            const imgData = canvas.toDataURL('image/png');
            const pdf = new jsPDF({
                orientation: "landscape",
                unit: "pt",
                format: [canvas.width, canvas.height],
            });
            pdf.addImage(imgData, 'PNG', 0, 0, canvas.width, canvas.height);
            pdf.save('psychometric_chart.pdf');
        });
    };
    useEffect(() => { 
    console.log('Chart Data:', chartData);
    console.log('Has percentage values?', chartData.map(d => d.percentage));
}, [chartData]);
    return (
        <>
{chartData.every(item => item.percentage === 0) ? (
    <div style={{ textAlign: 'center', padding: '40px',height:"50px",overflow:"hidden" }}>
                          <h2 style={{ textAlign: 'center', marginBottom: '10px',height:"50px" , fontSize:"20px", fontWeight:"600"}}>Psychometric Test Chart</h2>
        <p style={{height:"100%"}}>No data available yet.</p>
    </div>
) :( 
            <div className='chart-container' ref={chartRef} style={{ background: '#fff', padding: '20px' }}>

                  <h2 style={{ textAlign: 'center', marginBottom: '40px',height:"50px" }}>Psychometric Test Chart</h2>

       <ResponsiveContainer width="90%" height={300}>
                    <BarChart data={chartData} layout="vertical" margin={{ top: 10, right: 30, left: 20, bottom: 10 }} barSize={40}>
                        <XAxis type="number" domain={[0, 100]} tickCount={11} tick={{ fontSize: 14 }} />
                        <YAxis dataKey="tag" type="category" width={150} tick={{ fontSize: 14 }} />
                        <Tooltip formatter={(value) => `${value.toFixed(2)}%`} />
                        <Bar dataKey="percentage" radius={[0, 8, 8, 0]}>
                            {chartData.map((entry, index) => (
                                <Cell key={`cell-${index}`} fill={entry.color} />
                            ))}
                        </Bar>
                    </BarChart>
                </ResponsiveContainer>
                  <div style={{ width: '90%', marginTop: '60px', display: 'flex',  overflow: 'visible',flexDirection: 'column', alignItems: 'center',marginTop:'180px' }}>
                        <h2 style={{ textAlign: 'center', marginBottom: '40px',height:"40px" }}>Distribution by Tag</h2>
                        
                        <div style={{ width: '100%', height: '600px', display: 'flex', justifyContent: 'center', overflow: 'hidden', }}>
                            <ResponsiveContainer width="80%" height="100%" style={{overflow:"auto"}}>
                                <PieChart>
                                    <Pie
                                        data={chartData}
                                        cx="50%"
                                        cy="45%"
                                        labelLine={true}
                                        label={(entry) => `${entry.percentage.toFixed(1)}%`}
                                        outerRadius={100}
                                        dataKey="percentage"
                                    >
                                        {chartData.map((entry, index) => (
                                            <Cell key={`cell-${index}`} fill={entry.color} style={{ height:"70px" }}/>
                                        ))}
                                    </Pie>
                                    <Tooltip formatter={(value) => `${value.toFixed(2)}%`} />
                                    <Legend 
                                        verticalAlign="bottom"
                                        height={38}
                                        formatter={(value, entry) => entry.payload.tag} 
                
                                    />
                                </PieChart>
                            </ResponsiveContainer>
                        </div>
                    </div>
            </div>)}
        </>
    );
}

export default PsychometricTestChart;
